import { IRequestFilters } from "@/models";

class CacheService {

    public setRequestFiltersToCache(filters: IRequestFilters, archives: boolean): void {
        const filtersName = archives ? "archivesFilters" : "requestsFilters"
        const jsonData = JSON.stringify(filters);
        sessionStorage.setItem(filtersName, jsonData);
    }

    public getRequestFiltersFromCache(archives: boolean): IRequestFilters | null {
        const filtersName = archives ? "archivesFilters" : "requestsFilters"
        const jsonFilters = sessionStorage.getItem(filtersName);
        const filters = JSON.parse(jsonFilters);
        if (filters) {
            return filters;
        }

        sessionStorage.removeItem(filtersName);
        return null;
    }
}

const cacheService = new CacheService();

export { CacheService, cacheService };